// import html2canvas from 'html2canvas';
import DomToImage from 'dom-to-image';

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default class Screenshot {
  static openModal({ outerWrapper = '', printWrapper = '', appendArea = '', addClassOnClone = '', width = 600, height = 1200, filename = 'minha-selecao.jpg', backgroundColor = '#fff' }) {
    document.addEventListener('keyup', Screenshot.pressedESC);
    $(document).on('click', '.screenshot__button-close', Screenshot.closeModal);

    // Esconde os botões de compartilhamento e download
    if (isIOS) {
      $('.screenshot__content-area .loading').addClass('hidden');
      $('.screenshot-content-area').addClass('hidden');
      $('.screenshot__subtitle').addClass('hidden');
      $('.screenshot__submit-area').addClass('hidden');
    } else {
      setTimeout(() => $('.screenshot__content-area .loading').removeClass('hidden'), 500);
    }

    $('.screenshot__wrapper').fadeIn();

    Screenshot.now({
      outerWrapper,
      printWrapper,
      appendArea,
      addClassOnClone,
      width,
      height,
      filename,
      backgroundColor,
    });
  }

  static pressedESC(event) {
    const isEscKey = event.keyCode === 27;

    if (event.keyCode) {
      if (isEscKey) {
        Screenshot.closeModal();
      }
    }
  }

  static closeModal() {
    $('.screenshot__wrapper').fadeOut();
    setTimeout(() => $('#screenshot').attr('src', null), 500);
    document.removeEventListener('keyup', Screenshot.pressedESC);
  }

  /**
   * @param {string} outerWrapper Seletor do elemento a ser fotografado
   * @param {string} appendArea Seletor do elemento que servirá de moldura para a foto gerada
   * @param {string} addClassOnClone Classes para serem adicionadas no momento da fotografia
   * @param {string} printWrapper Elemento a ser fotografado
   * @param {integer} width Largura em pixels da foto gerada
   * @param {integer} height Altura em pixels da foto gerada
   * @param {string} filename Nome do arquivo ao ser baixado
   * @param {string} backgroundColor Cor de fundo da imagem. Valor em hexadecimal
   */
  static now({ outerWrapper = '', appendArea = '', printWrapper = '', addClassOnClone = '', width = 600, height = 1200, filename = 'minha-imagem.jpg', backgroundColor = '#fff' }) {
    // Desabilita os botões durante geração da imagem
    $('.screenshot__button-close').css('pointer-events: none;');
    $('#screenshot-share-fb').css('pointer-events: none;');
    $('#screenshot-download').css('pointer-events: none;');

    if (isIOS) {
      // TODO rever iOS
      // html2canvas(document.querySelector(outerWrapper), { // eslint-disable-line
      //   useCORS: true,
      //   background: backgroundColor,
      //   proxy: 'interativos.globoesporte.globo.com',
      //   letterRendering: true,
      //   windowWidth: width,
      //   windowedHeight: height,
      //   onclone(document) {
      //     document.querySelector(outerWrapper).classList.add(addClassOnClone);
      //   },
      // }).then((data) => {
      //   const dataUrl = data.toDataURL('image/jpeg');
      //
      //   $('#screenshot').attr('src', dataUrl); // Preview da imagem final
      //
      //   // Esconde ícone de carregamento
      //   $('.screenshot__content-area .loading').addClass('hidden');
      //
      //   // Habilita compartilhamento no facebook
      //   $('#screenshot-share-fb').css('pointer-events: auto;');
      //   $('#screenshot-share-fb').attr('data-image', dataUrl);  // Código para facebook
      // });
    } else {
      const optionsDOMToImage = { quality: 1, bgcolor: backgroundColor, height, width };

      // Prepara o elemento para gerar a imagem
      $(outerWrapper)
        .clone()
        .addClass(addClassOnClone)
        .appendTo($(appendArea));

      DomToImage
        .toJpeg(document.querySelector(printWrapper), optionsDOMToImage)
        .then((dataUrl) => {
          // Habilita os botões do modal
          $('.screenshot__button-close').css('pointer-events: auto;');
          $('#screenshot-share-fb').css('pointer-events: auto;');
          $('#screenshot-download').css('pointer-events: auto;');


          $('.screenshot__content-area .loading').addClass('hidden'); // Esconde ícone de carregamento

          // Cria download
          const link = document.createElement('a');
          link.download = filename;
          link.href = dataUrl;

          $('#screenshot').attr('src', dataUrl); // Preview da imagem final

          $('#screenshot-download').on('click', () => link.click()); // Habilita download

          $('#screenshot-share-fb').attr('data-image', dataUrl);  // Código para facebook
        });
    }
  }
}



// WEBPACK FOOTER //
// local_static/templates/guias/2018/partials/components/screenshot/screenshot.js